import { Route, Routes } from "react-router-dom";
import LayoutContainer from "../containers/layout/LayoutContainer";
import ProtectedRoute from "./ProtectedRoute";
import { Congratulations, Home, QuotationProcess } from "../../pages";

export default function Main({ isMobile }) {
	const getRedirectPath = () => {
		return null;
	};

	const redirectPath = getRedirectPath();

	return (
		<LayoutContainer>
			<Routes>
				<Route
					path="/"
					element={
						<ProtectedRoute
							isAllowed={!redirectPath}
							redirectPath={redirectPath || "/"}
						>
							<Home isMobile={isMobile} />
						</ProtectedRoute>
					}
				/>

				<Route
					path="/quotationProcess"
					element={
						<ProtectedRoute
							isAllowed={!redirectPath}
							redirectPath={redirectPath || "/"}
						>
							<QuotationProcess isMobile={isMobile} />
						</ProtectedRoute>
					}
				/>

				<Route
					path="/finishProcess"
					element={
						<ProtectedRoute
							isAllowed={!redirectPath}
							redirectPath={redirectPath || "/"}
						>
							<Congratulations />
						</ProtectedRoute>
					}
				/>

				<Route
					path="*"
					element={
						<main style={{ padding: "1rem" }}>
							<p>There's nothing here!</p>
						</main>
					}
				/>
			</Routes>
		</LayoutContainer>
	);
}
